import { DashboardFilterValues, DashboardSlideParams } from '@ardoq/api-types';
import { isEmpty } from 'lodash';

/**
 * A slide the author saved with filter values shows that fixed slice: the
 * viewer neither sees the filter island nor can widen the data, mirroring how
 * presentation report slides treat persisted `reportParams.filters`.
 */
export const isSlideFilterLocked = (
  dashboardParams: DashboardSlideParams | null
): boolean => !isEmpty(dashboardParams?.globalFilterValues);

export const getEffectiveFilterValues = (
  dashboardParams: DashboardSlideParams | null,
  viewerFilterValues: DashboardFilterValues | undefined
): DashboardFilterValues | undefined => {
  if (isSlideFilterLocked(dashboardParams)) {
    return dashboardParams?.globalFilterValues;
  }
  return isEmpty(viewerFilterValues) ? undefined : viewerFilterValues;
};

/**
 * What to send to the presentation dashboard endpoint. A locked slide sends
 * nothing: the backend applies the slide's persisted values itself, and only
 * an unlocked slide may be filtered from the client.
 */
export const getRequestFilterValues = (
  dashboardParams: DashboardSlideParams | null,
  viewerFilterValues: DashboardFilterValues | undefined
): DashboardFilterValues | undefined => {
  if (isSlideFilterLocked(dashboardParams)) return undefined;
  return isEmpty(viewerFilterValues) ? undefined : viewerFilterValues;
};
